module.exports = __webpack_public_path__ + "img/i-groups-admin.03d98c6c.svg";